// extracted by mini-css-extract-plugin
module.exports = {"cell":"idt-radiogroup_cell__10jle","label":"idt-radiogroup_label__1wmea"};